import { init } from '@rematch/core';
import { data } from './models/quiz';
import { time } from './models/time';

export const store = init({
  models: { data, time },
});
